import React from 'react'
import styled from 'styled-components'
import LinearProgress from '@mui/material/LinearProgress';

import {
  useNavigate
} from 'react-router-dom'

const LoadingBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  font-weight: 4rem;

  font-family: Montserrat;
  font-weight: bold;
  height: 100vh;

  flex-direction: row;

  color: tomato;

  @media (max-width: 700px) {
    width: 80vw;
    font-size: 2rem;
    font-weight: bold;

    border: 1px solid #F8F8F8;
  }
`

const ErrorBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  font-weight: 4rem;

  font-family: Montserrat;
  font-weight: bold;
  height: 100vh;

  flex-direction: column;

  color: tomato;
`

const ErrorBody = styled.div`
  color: black;
  font-size: 2rem;
  font-weight: bold;

  margin-bottom: 2vh;
`

const LoginLink = styled.button`
  background: tomato;
  color: white;
  border-radius: 5px;

  font-size: 2rem;
  font-weight: bold;
`

export default function AuthWrapper({ children, department }) {

  let navigate = useNavigate()

  const [hasAccess, setHasAccess] = React.useState(false);
  const [loading, setLoading] = React.useState(true)

  const authoriseRouteAccess = async () => {
    try {
      // https://ic360portalbackend.azurewebsites.net
      const response = await fetch(`https://ic360portalbackend.azurewebsites.net/api/auth/checkRouteAccess/${department}`, {
        method: "GET",
        headers: {
          'Content-type': 'application/JSON',
        },
        credentials: "include",
      })

      const data = await response.json();

      if (data.access === "Access Granted") {
        setHasAccess(true)
      } else {
        setHasAccess(false)
      }

    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false); // Set loading to false regardless of whether it was a success or failure
    }
  }

  React.useEffect(() => {
    authoriseRouteAccess()
  }, [])

  // Loading condition
  if (loading) {
    return (
      <LoadingBanner>

        <div>
          <span style={{ color: "black" }}>Loading</span>&nbsp;Data...
          <LinearProgress
            sx={{
              width: '100%', background: "black", 
              '& .MuiLinearProgress-bar': {
                backgroundColor: 'tomato',
              },
            }} />
        </div>
      </LoadingBanner>
    )
  }

  if (!hasAccess) {
    return (
      <ErrorBanner>
        <div>Access Denied</div>
        <ErrorBody>Please log in with a different user</ErrorBody>
        <LoginLink onClick={()=>{navigate('/login')}}>Login</LoginLink>
      </ErrorBanner>
    )
  }

  return (
    <>{children}</>
  )
}
